import React, { FC } from "react";
import { ModalViewModel } from "../../Blocks/PopUp/ModalViewModel.csharp";
import { PopUpContainer } from "../BookingLegacy/FormElements/PopUps/PopUpContainer";

type WaitWhileModalProps = {
  Modal: any;
  isOpen: boolean;
  buttonCloseFunction: (args: boolean) => void;
  modalViewModel: ModalViewModel;
};

export const WaitWhileModal: FC<WaitWhileModalProps> = ({
  Modal,
  isOpen,
  buttonCloseFunction,
  modalViewModel,
}) => {
  const closeButtonLabel = modalViewModel?.button?.link.title;

  return (
    <PopUpContainer
      Modal={Modal}
      isOpen={isOpen}
      handleCloseButtonClick={buttonCloseFunction}
      closeButtonLabel={closeButtonLabel}
    >
      {modalViewModel && (
        <>
          {modalViewModel.header && <h3>{modalViewModel.header}</h3>}
          <div
            dangerouslySetInnerHTML={{ __html: modalViewModel.description }}
          />
          <div className="d-flex justify-content-center mt-2">
            <button
              className="btn btn-primary"
              onClick={() => buttonCloseFunction(false)}
            >
              {closeButtonLabel ?? "Lukk"}
            </button>
          </div>
        </>
      )}
    </PopUpContainer>
  );
};
